import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	user_id: data.userId,
	mail_reports: data.mailReports,
});
